module.exports = __webpack_public_path__ + "static/img/normal-temperature-count.9671165.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/track/2/normal-temperature-count.png
// module id = YWqp
// module chunks = 1